// src/components/shared/AccessibilityStatementPage.tsx
// דף הצהרת נגישות - נגיש לכולם

import React from "react";
import { useNavigate } from "react-router-dom";
import AccessibilityWidget from "./AccessibilityWidget";

const AccessibilityStatementPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <>
      <AccessibilityWidget />

      <main
        className="min-h-screen bg-gray-50 py-8 px-4 sm:px-6 lg:px-8"
        dir="rtl"
      >
        <div className="max-w-5xl mx-auto bg-white rounded-lg shadow-lg p-8 sm:p-12">
          {/* Header */}
          <div className="mb-8 flex items-center justify-between border-b pb-6">
            <div>
              <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-2">
                הצהרת נגישות
              </h1>
              <p className="text-lg text-gray-600">עודכן: 1/1/2026</p>
            </div>
            <button
              onClick={() => navigate(-1)}
              className="flex items-center gap-2 px-4 py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-lg transition-colors"
            >
              <svg
                className="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M10 19l-7-7m0 0l7-7m-7 7h18"
                />
              </svg>
              <span className="hidden sm:inline">חזור</span>
            </button>
          </div>

          {/* Content */}
          <div className="space-y-8">
            {/* כותרת ראשית */}
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                הצהרת נגישות - CARTAX (עודכן: 21.10.2025)
              </h2>
              <p className="text-gray-700">
                קאר טאקס בע״מ (ח.פ. 517152609) מחויבת להנגשת אתר www.cartax.org
                בהתאם לתקנות שוויון זכויות לאנשים עם מוגבלות (התאמות נגישות
                לשירות), התשע״ג-2013 ולתקן הישראלי ת״י 5568 (WCAG 2.0 רמה AA).
              </p>
            </div>

            {/* מה בוצע */}
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                מה בוצע:
              </h2>
              <div className="space-y-2 text-gray-700">
                <p>• מבנה כותרות תקין וניווט מלא באמצעות מקלדת</p>
                <p>• יחס ניגודיות טקסט/רקע בהתאם לרמה AA</p>
                <p>• הגדלת טקסט עד 200% ללא אובדן מידע</p>
                <p>• חלופות טקסט לתמונות (ככל הניתן)</p>
                <p>• שימוש סביר ב-ARIA לתמיכה בטכנולוגיות מסייעות</p>
              </div>
            </div>

            {/* מסמכים */}
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                מסמכים/קבצים:
              </h2>
              <p className="text-gray-700">
                אנו פועלים להנגשת קבצי PDF מרכזיים; נשלח גרסה נגישה לפי בקשה.
              </p>
            </div>

            {/* חריגות */}
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                חריגות ידועות:
              </h2>
              <p className="text-gray-700">
                ייתכנו אזורים בהנגשה חלקית; אנו משפרים באופן מתמשך.
              </p>
            </div>

            {/* דפדפנים */}
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                דפדפנים נתמכים:
              </h2>
              <p className="text-gray-700">
                מומלץ להשתמש בגרסאות עדכניות של Chrome/Edge/Firefox/Safari.
              </p>
            </div>

            {/* פניות */}
            <div className="bg-blue-50 border-2 border-blue-300 rounded-lg p-8">
              <h2 className="text-2xl font-bold text-blue-900 mb-4">
                פניות בענייני נגישות:
              </h2>
              <div className="space-y-3 text-gray-800">
                <p>
                  <strong>דוא״ל:</strong> Info@cartax.org
                </p>
                <p>
                  <strong>טלפון:</strong> 054-4512136 (א׳-ה׳ 9:00-17:00)
                </p>
                <p>
                  נשמח לטפל בפנייתכם במהירות וביעילות. אנא ציינו את הדף
                  הרלוונטי, תיאור הבעיה, המכשיר/דפדפן.
                </p>
              </div>
            </div>
          </div>

          {/* Print Button */}
          <div className="mt-8 flex justify-center">
            <button
              onClick={() => window.print()}
              className="flex items-center gap-2 px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-semibold"
            >
              <span>הדפס עמוד</span>
            </button>
          </div>
        </div>
      </main>
    </>
  );
};

export default AccessibilityStatementPage;
